"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitMultiline = omitMultiline;
/**
 * Получив объект, вернет его копию но без свойства multiline.
 * @param source Объект.
 * @return Копия без свойства multiline.
 */
function omitMultiline(source) {
    const next = { ...source };
    delete next.multiline;
    return next;
}
//# sourceMappingURL=utils.js.map